export const Appconstants = {
    profilePageId:'ProfileComponent',
    thingsToDoPageId:'ThingsToDoCompoent',
    signUpPageId:'SignUpComponent',
    taxFormsPageId:'TaxFormComponent',
    taxFormsNonResidentialPageId:'TaxFormsNonResidentialComponent',
    accessToken: 'accesstoken',
    submit:'Submit',
    success:'success',
    app:'APP',
    investorPortal:'Investorportal',
    ver:'1.0',
    dpversion:'1.4', // Updated dp version to 1.4
    verify:'Verify',
    dataPrivacyPageId:'DataprivacyComponent',
    error:'error',
    failure:'failure',
    documentDownload:"DocumentDownload",
    deleteDoc:"DeleteDocument"
}